export type MetricToggleKey = keyof typeof MetricToggle;

export enum MetricToggle {
    showValue = "Values",
    showSubtotals = "Subtotals",
    showTotals = "Totals",
}

export enum TopLevelToggle {
    showAssortmentTotals = "Show assortment totals",
    showPlan = "Show plan",
}

export enum ItemTypes {
    CARD = "card",
}
